import { render, staticRenderFns } from "./RefundModalForm.vue?vue&type=template&id=87c00e2e&"
import script from "./RefundModalForm.vue?vue&type=script&lang=js&"
export * from "./RefundModalForm.vue?vue&type=script&lang=js&"
import style0 from "./RefundModalForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports